export type PlayerApplicationStatus = 'pending' | 'accepted' | 'rejected';

/** A backend PlayerApplicationStatus enum számértékei (szűréshez). */
export const PLAYER_APPLICATION_STATUS_CODES: Record<PlayerApplicationStatus, number> = {
  pending: 0,
  accepted: 1,
  rejected: 2,
};

export interface PlayerApplication {
  id: number;
  playerName: string;
  birth: string;
  gender: string;
  placeOfBirth?: string | null;
  address?: string | null;
  playerPhone?: string | null;
  parentName: string;
  parentEmail: string;
  parentPhone: string;
  emergencyContactName?: string | null;
  emergencyContactPhone?: string | null;
  medicalNotes?: string | null;
  previousClub?: string | null;
  note?: string | null;
  suggestedAgeGroupId?: number | null;
  suggestedAgeGroupName?: string | null;
  termsAcceptedAt?: string | null;
  status: PlayerApplicationStatus;
  createdAt: string;
  decidedAt?: string | null;
  decidedByUserName?: string | null;
  rejectionReason?: string | null;
  createdPlayerId?: number | null;
  possibleDuplicate: boolean;
}

export interface SubmitPlayerApplicationRequest {
  playerName: string;
  birth: string;
  gender: string;
  placeOfBirth?: string;
  address?: string;
  playerPhone?: string;
  parentName: string;
  parentEmail: string;
  parentPhone: string;
  emergencyContactName?: string;
  emergencyContactPhone?: string;
  medicalNotes?: string;
  previousClub?: string;
  note?: string;
  termsAccepted: boolean;
  /** Csapda a robotoknak - ember nem tölti ki. */
  website?: string;
}

export interface AcceptPlayerApplicationResult {
  application: PlayerApplication;
  parentLinked: boolean;
  invitationSent: boolean;
  invitationError?: string | null;
}
